/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ArticleTeaser/theme';

export const ArticleTeaserTheme = theme;
